// DeckPage.jsx
import React, { useEffect, useState } from 'react';
import './DeckPage.css';

const DeckPage = () => {
  const [mainDeck, setMainDeck] = useState([]);
  const [extraDeck, setExtraDeck] = useState([]);
  const [sideDeck, setSideDeck] = useState([]);
  const [savedDecks, setSavedDecks] = useState([]);
  const [deckName, setDeckName] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('deckBox');
    if (saved) {
      setSavedDecks(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('deckBox', JSON.stringify(savedDecks));
  }, [savedDecks]);

  const fetchCardById = async (id) => {
    try {
      const res = await fetch(`https://db.ygoprodeck.com/api/v7/cardinfo.php?id=${id}`);
      const data = await res.json();
      if (data?.data?.[0]) {
        return {
          id: data.data[0].id,
          name: data.data[0].name,
          image: data.data[0].card_images[0].image_url
        };
      }
    } catch (err) {
      console.error('Card fetch error:', err);
    }
    return null;
  };

  const handleYdkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const text = await file.text();
    const lines = text.split('\n');

    let currentSection = 'main';
    const mainIds = [];
    const extraIds = [];
    const sideIds = [];

    for (const line of lines) {
      if (line.startsWith('#')) {
        if (line.includes('main')) currentSection = 'main';
        else if (line.includes('extra')) currentSection = 'extra';
        continue;
      }
      if (line.startsWith('!side')) {
        currentSection = 'side';
        continue;
      }
      const trimmed = line.trim();
      if (!/^\d+$/.test(trimmed)) continue;

      if (currentSection === 'main') mainIds.push(trimmed);
      else if (currentSection === 'extra') extraIds.push(trimmed);
      else if (currentSection === 'side') sideIds.push(trimmed);
    }

    const mainCards = (await Promise.all(mainIds.map(fetchCardById))).filter(Boolean);
    const extraCards = (await Promise.all(extraIds.map(fetchCardById))).filter(Boolean);
    const sideCards = (await Promise.all(sideIds.map(fetchCardById))).filter(Boolean);

    setMainDeck(mainCards);
    setExtraDeck(extraCards);
    setSideDeck(sideCards);

    const autoDeck = {
      name: `Imported Deck ${Date.now()}`,
      main: mainCards,
      extra: extraCards,
      side: sideCards
    };
    setSavedDecks(prev => [...prev, autoDeck]);
  };

  const saveCurrentDeck = () => {
    if (!deckName.trim()) return;
    const newDeck = {
      name: deckName.trim(),
      main: mainDeck,
      extra: extraDeck,
      side: sideDeck
    };
    setSavedDecks(prev => [...prev, newDeck]);
    setDeckName('');
  };

  return (
    <div className="deck-page">
      <h2>Your Deck</h2>

      <div className="deck-input">
        <input type="file" accept=".ydk" onChange={handleYdkUpload} />
      </div>

      <div className="save-deck-box">
        <input
          type="text"
          value={deckName}
          onChange={(e) => setDeckName(e.target.value)}
          placeholder="Name this deck"
        />
        <button onClick={saveCurrentDeck}>Save Deck</button>
      </div>

      <h3>Main Deck</h3>
      <div className="deck-grid">
        {mainDeck.map((card) => (
          <div key={card.id} className="card-preview">
            <img
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable={false}
              src={card.image} alt={card.name} />
            <p>{card.name}</p>
          </div>
        ))}
      </div>

      <h3>Extra Deck</h3>
      <div className="deck-grid">
        {extraDeck.map((card) => (
          <div key={card.id} className="card-preview">
            <img
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable={false}
              src={card.image} alt={card.name} />
            <p>{card.name}</p>
          </div>
        ))}
      </div>

      <h3>Side Deck</h3>
      <div className="deck-grid">
        {sideDeck.map((card) => (
          <div key={card.id} className="card-preview">
            <img
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable={false}
              src={card.image} alt={card.name} />
            <p>{card.name}</p>
          </div>
        ))}
      </div>

      <h3>Deck Box</h3>
      <ul className="deck-box-list">
        {savedDecks.map((d, idx) => (
          <li key={idx}>
            <strong>{d.name}</strong> — {d.main.length} Main / {d.extra.length} Extra / {d.side.length} Side
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeckPage;
